import Vue from 'vue';
import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload, {
  // error: 'dist/error.png',
  // loading: 'dist/loading.gif',
});
